import { render } from "./ProfileJobCompetenceScoring.vue?vue&type=template&id=49ad8342&scoped=true"
import script from "./ProfileJobCompetenceScoring.vue?vue&type=script&lang=js"
export * from "./ProfileJobCompetenceScoring.vue?vue&type=script&lang=js"

import "./ProfileJobCompetenceScoring.vue?vue&type=style&index=0&id=49ad8342&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ad8342"]])

export default __exports__